export const PRIZE_LIST = [
  { type: "Common", prize: "12.5k" },
  { type: "Uncommon", prize: "53k" },
  { type: "Superior", prize: "270k" },
  { type: "Epic", prize: "1.5M" },
  { type: "Lengendary", prize: "3.58M" },
];
/**
 * role_type
 * 1 - prototype
     2 - common
     3 - uncommon
     4 - superior
     5 - epic
     6 - legendary
 */
export const PRIZE_TYPE = {
  2: "12.5k",
  3: "53k",
  4: "270k",
  5: "1.5M",
  6: "3.58M",
};

export const TICKET_TYPE = {
  2: "165",
  3: "450",
  4: "2.4k",
  5: "15k",
  6: "45k",                                                                                                          
};

/**
 * role_property
 1 - wind
2 - rock
3 - ice
4 - fire
5 - thunder
 */
// export const YULI_BG_TYPE = {
//   3: require("@/assets/images/YuliApp/storageActivity/yuliBg/ice_bg.png"),
//   2: require("@/assets/images/YuliApp/storageActivity/yuliBg/rock_bg.png"),
//   4: require("@/assets/images/YuliApp/storageActivity/yuliBg/fire_bg.png"),
//   5: require("@/assets/images/YuliApp/storageActivity/yuliBg/thunder_bg.png"),
//   1: require("@/assets/images/YuliApp/storageActivity/yuliBg/wind_bg.png"),
// };
export const YULI_SX_TYPE = {
  3: require("@/assets/images/YuliApp/storageActivity/iconAttr/icon_ice_bg@2x.png"),
  2: require("@/assets/images/YuliApp/storageActivity/iconAttr/icon_rock_bg@2x.png"),
  4: require("@/assets/images/YuliApp/storageActivity/iconAttr/icon_fire_bg@2x.png"),
  5: require("@/assets/images/YuliApp/storageActivity/iconAttr/icon_thunder_bg@2x.png"),
  1: require("@/assets/images/YuliApp/storageActivity/iconAttr/icon_wind_bg@2x.png"),
};

/**
 * role_type
 * 1 - prototype
     2 - common
     3 - uncommon
     4 - superior
     5 - epic
     6 - legendary
 */
export const YULI_PZ_TYPE = {
  // prototype: require('@/assets/images/YuliApp/storageActivity/iconPz/icon_star_prototype@2x.png'),
  2: require("@/assets/images/YuliApp/storageActivity/iconPz/icon_star_normal@2x.png"),
  3: require("@/assets/images/YuliApp/storageActivity/iconPz/icon_star_rare@2x.png"),
  4: require("@/assets/images/YuliApp/storageActivity/iconPz/icon_star_superRare@2x.png"),
  5: require("@/assets/images/YuliApp/storageActivity/iconPz/icon_star_eple@2x.png"),
  6: require("@/assets/images/YuliApp/storageActivity/iconPz/icon_star_legend@2x.png"),
};

export const PZ_TYPE_NAME = {
  1: "wind",
  2: "rock",
  3: "ice",
  4: "fire",
  5: "thunder",
};

export const CONSUME_USERS = {
  market_good: "Shop Items",
  level_upgrade: "Upgrade Yuli",
  chip_upgrade: "Upgrade Chips",
  breed: "Breeding",
};
